import React, { useEffect } from 'react';
import { useStore } from '../../store';
import { Link, useNavigate } from 'react-router-dom';
import SRFButton from '../Inputs/SRFButton/SRFButton';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../../Utils/Functions/Dexie-Setup';


function Home() {
    const { isAuthed, signOut, translation } = useStore();
    const navigate = useNavigate();
    const numDrafts = useLiveQuery(() => db.dailyFieldReports.where("recordId").below(0).and(dfr => !(dfr?.submitted)).count(), []);
    const numPending = useLiveQuery(() => db.dailyFieldReports.where("recordId").below(0).and(dfr => (dfr?.submitted)).count(), []);
    const numSubmissions = useLiveQuery(() => db.dailyFieldReports.where("recordId").above(0).count(), []);

    useEffect(() => {
        if (!isAuthed) {
            navigate("/auth");
        }
    }, [isAuthed, navigate]);

    return (
        <div className='flex flex-col items-center pt-4 gap-2'>
            <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
                <Link to="/form">
                    <SRFButton color='#8fc13b'>➕ {translation.newDailyFieldReport}</SRFButton>
                </Link>
            </div>
            <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
                <Link to="/list/drafts">
                    <SRFButton color='#0f314d'>{translation.drafts} ({numDrafts})</SRFButton>
                </Link>
            </div>
            <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
                <Link to="/list/pending">
                    <SRFButton color='#0f314d'>{translation.pendingSubmissions} ({numPending})</SRFButton>
                </Link>
            </div>
            <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
                <Link to="/list/history">
                    <SRFButton color='#0f314d'>{translation.submissions} ({numSubmissions})</SRFButton>
                </Link>
            </div>
            <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
                <Link to="/settings">
                    <SRFButton color='#0f314d'>{translation.settings}</SRFButton>
                </Link>
            </div>
            <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
                <SRFButton 
                    onClick={() => 
                        window.confirm(translation.confirmLogout) ? signOut() : null
                    } 
                    color='#0f314d'
                >
                    {translation.logout}
                </SRFButton>
            </div>
        </div>
    );
}

export default Home;